import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { EnumChoicesTypeInfoFragment } from '../../generated.graphql';
import { BaseSummaryProps } from './types';
import { getEnumDisplay } from './utils';


interface Props extends BaseSummaryProps {
  bankStatementsResultEnum?: EnumChoicesTypeInfoFragment | null
}


export const BankStatementsSummary = ({ application, bankStatementsResultEnum }: Props) => {
  const steps = useRentalSteps({slug: slugs.bankStatements});
  const bankStatements = application?.bankStatements;
  
  return (
    <SummarySection>
      <SummaryHeader step={steps.this}>Bank Statements</SummaryHeader>
      {!bankStatements ? <LoadingLabel alignment="left" /> : (
        <div>{getEnumDisplay(bankStatements.result, bankStatementsResultEnum)}</div>
      )}
    </SummarySection>
  );
}